import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  Button,
  Space,
  Modal,
  Select,
  message,
  Typography,
  Input,
  Card,
  Checkbox,
  Divider,
  Upload,
} from "antd";
import dataService from "../networks/api/service/dataService";
import CustomTable from "./TableComponent/CustomTable";
import { WhatsAppOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./GreivanceTable.css";

const { Title, Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;


function GreivanceTable({
  grievances,
  loading,
  getNewGrievanceList,
  hideAssignedColumn,
}) {
  console.log("Received grievances:", grievances);
  const [selectedGrievance, setSelectedGrievance] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [admins, setAdmins] = useState([]);
const instance = process.env.REACT_APP_INSTANCE;

const userRole = localStorage.getItem("UserRole");
  const navigate = useNavigate();
  const role = localStorage.getItem("UserRole");
  const [districtById, setDistrictById] = useState({});
  const [statusChangeModalVisible, setStatusChangeModalVisible] =
    useState(false);
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [columnModalVisible, setColumnModalVisible] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedColumnKeys, setSelectedColumnKeys] = useState([
    "nameOfApplicant",
    "mobileNo",
    "district",
    "problemRelatedToSection",
    "levelOfIssue",
    "status",
    "assignedTo",
  ]);

  const users = [
    { id: 1, name: 'Alice Sharma' },
    { id: 2, name: 'Rahul Mehta' },
    { id: 3, name: 'Sneha Verma' },
  ];

  const showModal = () => {
    

    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setSelectedUsers([]);
    
    setIsModalOpen(false)
  };



  const handleShare = () => {

    if (selectedUsers.length > 0) {
      message.success(`Shared with: ${selectedUsers.join(', ')}`);
      setIsModalOpen(false);
      setSelectedUsers([]);
    } else {
      message.warning('Please select at least one user to share with.');
    }
  };


  useEffect(() => {

    console.log("Fetching Admins...");
    const fetchAdmins = async () => {
      try {
        const response = await dataService.getAllAdmin();
        console.log("Fetched Admins:", response); // Replace with correct API function

        setAdmins(response?.data || []); // Ensure response is an array
      } catch (error) {
        console.error("Error fetching admins:", error);
      }
    };

    fetchAdmins();

    const fetchDistricts = async () => {
      try {
        const response = await dataService.getDistrict();
        const districts = response?.data || [];
        const mapped = {};
        districts.forEach((district) => {
          if (district?._id) {
            mapped[district._id] = district.districtName || district.name;
          }
        });
        setDistrictById(mapped);
      } catch (error) {
        console.error("Error fetching districts:", error);
      }
    };

    fetchDistricts();
  }, []);

  const getDistrictName = (record) => {
    const districtValue = record?.district;
    if (typeof districtValue === "object" && districtValue) {
      return (
        districtValue.districtName ||
        districtValue.name ||
        districtById[districtValue._id] ||
        "-"
      );
    }
    if (record?.districtName) return record.districtName;
    if (!districtValue) return "-";
    return districtById[districtValue] || districtById[String(districtValue)] || "-";
  };
  const handleEdit = (record) => {
    const grievanceId =
      record._id || record.id || record.grievanceId || record.grievance_id;

    navigate("/login/grievance", {
      state: { grievanceData: { ...record, _id: grievanceId } },
    });

  };



  const columns = [
    {
      title: "Taken By",
      dataIndex: "takenBy",
      key: "email",
      width: 200,
      render: (value) => value || "-",
    },
    {
      title: "Applicant Name",
      dataIndex: "nameOfApplicant",
      key: "nameOfApplicant",
      width: 150,
    },
    {
      title: "Mobile",
      dataIndex: "mobileNo",
      key: "mobileNo",
      width: 150,
    },
    {
      title: "Section",
      dataIndex: "problemRelatedToSection",
      key: "problemRelatedToSection",
      width: 150,
    },
    {
      title: "Issue Level",
      dataIndex: "levelOfIssue",
      key: "levelOfIssue",
      width: 150,
    },
    {
      title: "Description",
      dataIndex: "descriptionOfProbles",
      key: "descriptionOfProbles",
      width: 260,
      ellipsis: true,
      render: (value) => value || "-",
    },
    // {
    //   title: "Authority",
    //   key: "authorityToBeSattled",
    //   width: 180,
    //   render: (_, record) =>
    //     record.authorityToBeSattled || record.authorityToBeSettled || "-",
    // },
    // {
    //   title: "Authority Name",
    //   dataIndex: "contactPersonName",
    //   key: "contactPersonName",
    //   width: 180,
    //   render: (value) => value || "-",
    // },
    // {
    //   title: "Contact No.",
    //   dataIndex: "contactPersonMobileNo",
    //   key: "contactPersonMobileNo",
    //   width: 150,
    //   render: (value) => value || "-",
    // },
    {
      title: "Mandal",
      dataIndex: "mandal",
      key: "mandal",
      width: 150,
      render: (value) => value || "-",
    },
    {
      title: "Ward",
      dataIndex: "ward",
      key: "ward",
      width: 120,
      render: (value) => value || "-",
    },
    {
      title: "District",
      key: "district",
      width: 150,
      render: (_, record) => getDistrictName(record),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 150,
      render: (status, record) => (
        <Select
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) => {
            const children = option?.children;
            return String(children).toLowerCase().includes(input.toLowerCase());
          }}
          value={status}
          onChange={(value) => handleStatusChange(value, record._id)}
          style={{ width: 150, border: "1px solid grey", borderRadius: 5 }}
        >
          <Option value="OPEN">OPEN</Option>
          <Option value="APPROVE">APPROVE</Option>
          <Option value="REJECT">REJECT</Option>
          <Option value="INFORMATION NEEDED">INFORMATION NEEDED</Option>
          <Option value="CLOSED">CLOSED</Option>
        </Select>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      width: 150,
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => handleRowClick(record)}>
            View Details
          </Button>
          {record.status !== "CLOSED"  && (
          <Button type="link" style={{ color: "blue" }} onClick={() => handleEdit(record)}>
            Edit
          </Button>
          )}
      {  userRole === "GRIEVANCEADMIN" && <Button type="link" style={{ color: "blue" }} onClick={showModal}>
            Share
          </Button>}
        </>
      ),
    },

  ];
  console.log(role, "role");
 if (!hideAssignedColumn && (role === "ADMIN" || role === "SUPERADMIN")) {

    columns.splice(columns.length - 1, 0, {
      title: "Assigned To",
      key: "assignedTo",
      width: 150,
      render: (_, record) => (
        <Select
          placeholder="Assign Admin"
          onChange={(value) => handleAssignGrievance(value, record._id)}
          value = {record?.assignedTo}
          style={{ width: 180 }}
          disabled={record.status !== "OPEN"} 
        >
          {admins?.filter(admin => admin.role === 'GRIEVANCEADMIN').map((admin) => (
            <Option key={admin._id} value={admin._id}>
              {admin.name}
            </Option>
          ))}
        </Select>
      ),
    });
  }

  const handleStatusChange = (value, grievanceId) => {
    console.log("GrivanceId:", grievanceId);
    setSelectedGrievance({
      grievanceId: grievanceId,
      status: value,
      comment: "",
    });
    setStatusChangeModalVisible(true);
  };

  const handleAssignGrievance = async (adminId, grievanceId) => {
    try {
      const response = await dataService.assignGrievance(grievanceId, adminId);

      message.success("Grievance assigned successfully");
      getNewGrievanceList(); // Fetch updated grievances after assignment
    } catch (error) {
      // message.error("Error assigning grievance");
    }
  };

  const handleRowClick = (record) => {
    setSelectedGrievance(record);
    setModalVisible(true);
  };

  const handleStatusUpdate = async () => {
    const { grievanceId, status, comment } = selectedGrievance;
    console.log("Updating Grievance Status:", selectedGrievance);
  
    try {
      const response = await dataService.updateGreivanceStatus(grievanceId, {
        status,
        comment,
      });
  
      if (response.code === 200) {
        message.success(`Grievance status updated to ${status}`);
  
        setFilteredData((prevData) => {
          // Update the item if it matches ID
          const updatedData = prevData.map((grievance) =>
            grievance._id === grievanceId
              ? { ...grievance, status, comment }
              : grievance
          );
  
          // Apply current filter (remove if it doesn't match selectedStatus)
          if (selectedStatus === "All") {
            return updatedData;
          }
  
          return updatedData.filter(
            (item) => item.status === selectedStatus
          );
        });
  
        // Optionally, update the parent data if grievances comes from parent
        getNewGrievanceList(); 
  
        setStatusChangeModalVisible(false);
        setSelectedGrievance(null);
      } else {
        message.error("Failed to update grievance status");
      }
    } catch (error) {
      message.error("Error updating status");
    }
  };
  

  const generateWhatsAppMessage = (grievance) => {
    if (!grievance) return "";
  
    const message = `
      Grievance Details:
      \nEmail: ${grievance.email}
      \nName: ${grievance.nameOfApplicant}
      \nMobile: ${grievance.mobileNo}
      \nSection: ${grievance.problemRelatedToSection}
      \nIssue Level: ${grievance.levelOfIssue}
      \nDescription: ${grievance.descriptionOfProbles}
      \nContact Person: ${grievance.contactPersonName}
      \nContact Person Mobile: ${grievance.contactPersonMobileNo}
      \nStatus: ${grievance.status}
      \n\nStatus History: 
      ${grievance.statusHistory
        ?.map(
          (history) => `
      \nStatus: ${history.status}
      \nUpdated At: ${new Date(history.updatedAt).toLocaleString()}
      ${history.comment ? `\nComment: ${history.comment}` : ""}
      `
        )
        .join("\n")}
    `;
    return message.trim(); // No need to encode since we're sending plain text
  };
  
  // const shareOnWhatsApp = async () => {
  //   try {
  //     const message = generateWhatsAppMessage(selectedGrievance);
  //     const mobile = 7735459901;
  
  //     if (!mobile || !message) {
  //       console.error("Missing mobile number or message content.");
  //       return;
  //     }
  
  //     const payload = {
  //       to: mobile,
  //       message,
  //     };
  
  //     const response = await dataService.Message(payload);
  //     console.log("WhatsApp message sent successfully:", response);
  //   } catch (error) {
  //     console.error("Error sending WhatsApp message:", error);
  //   }
  // };
  
  // const shareOnWhatsApp = async () => {
  //   try {
  //     const grievance = selectedGrievance;
  //     const mobile = grievance.mobileNo; // Or any recipient number
  
  //     if (!mobile || !grievance) {
  //       console.error("Missing mobile number or grievance data.");
  //       return;
  //     }
  
  //     const payload = {
  //       to: 7406151476,
  //       email: grievance.email,
  //       name: grievance.nameOfApplicant,
  //       mobile: grievance.mobileNo,
  //       section: grievance.problemRelatedToSection,
  //       level: grievance.levelOfIssue,
  //       description: grievance.descriptionOfProbles,
  //       contactPerson: grievance.contactPersonName,
  //       contactMobile: grievance.contactPersonMobileNo,
  //       status: grievance.status
  //     };
  
  //     const response = await dataService.Message(payload);
  //     console.log("WhatsApp message sent successfully:", response);
  //   } catch (error) {
  //     console.error("Error sending WhatsApp message:", error);
  //   }
  // };
  const shareOnWhatsApp = () => {
  if (!selectedGrievance) return;

  const message = `
 Grievance Details

 Applicant: ${selectedGrievance?.nameOfApplicant}
 Mobile: ${selectedGrievance?.mobileNo}
 Section: ${selectedGrievance?.problemRelatedToSection}
 Issue Level: ${selectedGrievance?.levelOfIssue}
 Description: ${selectedGrievance?.descriptionOfProbles}
 Status: ${selectedGrievance?.status}
`;

  const encodedMessage = encodeURIComponent(message);

  const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;

  window.open(whatsappUrl, "_blank");
};
  useEffect(() => {
    let data = [...grievances];
  
    if (selectedStatus !== "All") {
      data = data.filter((item) => item.status === selectedStatus);
    }

    const normalizedSearch = searchText.trim().toLowerCase();
    if (normalizedSearch) {
      data = data.filter((item) =>
        JSON.stringify(item || {}).toLowerCase().includes(normalizedSearch)
      );
    }
  
    setFilteredData(data);
  }, [grievances, selectedStatus, searchText]);

  const summary = useMemo(
    () => ({
      total: filteredData.length,
      open: filteredData.filter((item) => item.status === "OPEN").length,
      approved: filteredData.filter((item) => item.status === "APPROVE").length,
      rejected: filteredData.filter((item) => item.status === "REJECT").length,
      informationNeeded: filteredData.filter(
        (item) => item.status === "INFORMATION NEEDED"
      ).length,
      closed: filteredData.filter((item) => item.status === "CLOSED").length,
    }),
    [filteredData]
  );

  const columnOptions = columns
    .filter((column) => column.key !== "actions")
    .map((column) => ({ label: column.title, value: column.key }));
  const visibleColumns = columns.filter(
    (column) =>
      column.key === "actions" || selectedColumnKeys.includes(column.key)
  );
  
  return (
    <div className="grievance-list">
      <div className="grievance-list__header">
        <div>
          <Title level={2}>Grievance List</Title>
          <Text>Review, filter, and manage submitted grievances.</Text>
        </div>
      </div>

      <div className="grievance-list__toolbar">
        <Input
          className="grievance-list__search"
          placeholder="Search across all grievance details"
          value={searchText}
          onChange={(event) => setSearchText(event.target.value)}
          allowClear
        />
        <Select
          className="grievance-list__status-filter"
          placeholder="Filter by Status"
          value={selectedStatus}
          onChange={(value) => setSelectedStatus(value)}
        >
            <Option value="All">All</Option>
            <Option value="OPEN">OPEN</Option>
            <Option value="APPROVE">APPROVE</Option>
            <Option value="REJECT">REJECT</Option>
            <Option value="INFORMATION NEEDED">INFORMATION NEEDED</Option>
            <Option value="CLOSED">CLOSED</Option>
        </Select>
        <Button
          className="grievance-list__columns-button"
          onClick={() => setColumnModalVisible(true)}
        >
          <span className="grievance-list__columns-label">Columns</span>
          <span className="grievance-list__columns-count">
            {selectedColumnKeys.length}
          </span>
        </Button>
      </div>

      <div className="grievance-summary">
        {[
          ["Total", summary.total, "total"],
          ["Open", summary.open, "open"],
          ["Approved", summary.approved, "approved"],
          ["Rejected", summary.rejected, "rejected"],
          ["Info Needed", summary.informationNeeded, "info"],
          ["Closed", summary.closed, "closed"],
        ].map(([label, value, tone]) => (
          <Card
            key={label}
            size="small"
            className={`grievance-summary__card grievance-summary__card--${tone}`}
          >
            <Text>{label}</Text>
            <div>{value}</div>
          </Card>
        ))}
      </div>

      <div className="grievance-list__table">
        <CustomTable
          dataSource={filteredData}
          columns={visibleColumns}
          rowKey="_id"
          loading={loading}
          bordered
          pagination={{ pageSize: 5 }}
          scroll={{ x: 800 }}
          style={{ overflowX: "auto", whiteSpace: "nowrap" }}
        />
      </div>

      <Modal
          className="column-selector-modal"
          title={<span>Choose visible columns</span>}
          visible={columnModalVisible}
          onCancel={() => setColumnModalVisible(false)}
          onOk={() => setColumnModalVisible(false)}
          okText="Apply"
          width={420}
        >
          <Text className="column-selector-modal__description">
            Choose the details you want to see in the table. Actions remain available.
          </Text>
          <Space className="column-selector-modal__actions">
            <Button
              className="column-selector-modal__select-all"
              size="small"
              onClick={() =>
                setSelectedColumnKeys(columnOptions.map((option) => option.value))
              }
            >
              Select All
            </Button>
            <Button
              className="column-selector-modal__deselect-all"
              size="small"
              onClick={() => setSelectedColumnKeys([])}
            >
              Deselect All
            </Button>
          </Space>
          <Checkbox.Group
            className="column-selector-modal__checkboxes"
            value={selectedColumnKeys}
            onChange={setSelectedColumnKeys}
          >
            {columnOptions.map((option) => (
              <Checkbox key={option.value} value={option.value}>
                {option.label}
              </Checkbox>
            ))}
          </Checkbox.Group>
      </Modal>

        {/* Modal for displaying full details */}
        <Modal
          visible={modalVisible}
          title={
            <Title level={4} style={{ textAlign: "center", color: "#ff7118" }}>
              Grievance Details
            </Title>
          }
          footer={null}
          onCancel={() => setModalVisible(false)}
          style={{ top: 20 }}
          bodyStyle={{
            overflow: "auto",
            maxHeight: "80vh",
            padding: "1.5rem",
            backgroundColor: "#f9f9f9",
          }}
        >
          {selectedGrievance && (
            <div
              style={{ display: "flex", flexDirection: "column", gap: "1rem" }}
            >
              <Card bordered={false} style={{ backgroundColor: "#fff" }}>
                <Text strong>Taken By:</Text>{" "}
                <Text>{selectedGrievance.takenBy}</Text>
                <Divider style={{ margin: "0.5rem 0" }} />
                <Text strong>Name:</Text>{" "}
                <Text>{selectedGrievance.nameOfApplicant}</Text>
                <Divider style={{ margin: "0.5rem 0" }} />
                <Text strong>Mobile:</Text>{" "}
                <Text>{selectedGrievance.mobileNo}</Text>
                <Divider style={{ margin: "0.5rem 0" }} />
                <Text strong>District:</Text>{" "}
                <Text>
                  {getDistrictName(selectedGrievance)}
                </Text>
                <Divider style={{ margin: "0.5rem 0" }} />
                <Text strong>Mandal:</Text>{" "}
                <Text>{selectedGrievance.mandal || "-"}</Text>
                <Divider style={{ margin: "0.5rem 0" }} />
                <Text strong>Ward:</Text>{" "}
                <Text>{selectedGrievance.ward || "-"}</Text>
                <Divider style={{ margin: "0.5rem 0" }} />
                <Text strong>Section:</Text>{" "}
                <Text>{selectedGrievance.problemRelatedToSection}</Text>
                <Divider style={{ margin: "0.5rem 0" }} />
                <Text strong>Issue Level:</Text>{" "}
                <Text>{selectedGrievance.levelOfIssue}</Text>
                <Divider style={{ margin: "0.5rem 0" }} />
                <Text strong>Description:</Text>{" "}
                <Text>{selectedGrievance.descriptionOfProbles}</Text>
                <Divider style={{ margin: "0.5rem 0" }} />
                <Text strong>Contact Person Name:</Text>{" "}
                <Text>{selectedGrievance.contactPersonName}</Text>
                <Divider style={{ margin: "0.5rem 0" }} />
                <Text strong>Contact Person Mobile:</Text>{" "}
                <Text>{selectedGrievance.contactPersonMobileNo}</Text>
                <Divider style={{ margin: "0.5rem 0" }} />
                {selectedGrievance?.docs ? (
                  <>
                    <Text strong>Uploaded File:</Text>
                    <Upload
                      fileList={[
                        {
                          uid: "-1",
                          name: selectedGrievance.docs?.split("/").pop() || "Unknown File",
                          status: "done",
                          url: selectedGrievance.docs,
                        },
                      ]}
                      showUploadList={{ showPreviewIcon: true, showRemoveIcon: false }}
                      onPreview={(file) => window.open(file.url, "_blank")}
                    />
                    <Divider style={{ margin: "0.5rem 0" }} />
                  </>
                ) : (
                  <>
                    <Text strong>Uploaded File:</Text> <Text>N/A</Text>
                    <Divider style={{ margin: "0.5rem 0" }} />
                  </>
                )}
                <Text strong>Status:</Text>{" "}
                <Text style={{ fontWeight: "bold", color: "#52c41a" }}>
                  {selectedGrievance.status}
                </Text>
              </Card>

              {/* Status History */}
              <Card
                title="Status History"
                bordered={false}
                style={{
                  marginTop: "1rem",
                  backgroundColor: "#fafafa",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                }}
              >
                <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                  {selectedGrievance.statusHistory?.map((history) => (
                    <li
                      key={history._id}
                      style={{
                        marginBottom: "1rem",
                        padding: "0.8rem",
                        backgroundColor: "#fff",
                        borderRadius: "6px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      }}
                    >
                      <Text strong style={{ color: "#1890ff" }}>
                        {history.status}
                      </Text>
                      <br />
                      <Text type="secondary" style={{ fontSize: "0.9rem" }}>
                        Updated At:{" "}
                        {new Date(history.updatedAt).toLocaleString()}
                      </Text>
                      {/* {history.comment && (
                        <Text
                          style={{
                            display: "block",
                            marginTop: "0.5rem",
                            color: "#595959",
                          }}
                        >
                          Comment: {history.comment}
                        </Text>
                      )} */}
                    </li>
                  ))}
                </ul>
              </Card>
              <Button
                type="primary"
                icon={<WhatsAppOutlined />}
                onClick={shareOnWhatsApp}
                style={{
                  marginTop: "1rem",
                  backgroundColor: "#25D366", // WhatsApp Green color
                  borderColor: "#25D366", // WhatsApp Green border color
                }}
              >
                Share on WhatsApp
              </Button>
            </div>
          )}
        </Modal>

        {/* Modal for Changing Status */}
        <Modal
          visible={statusChangeModalVisible}
          title={`Changing Status to "${selectedGrievance?.status}"`}
          onCancel={() => setStatusChangeModalVisible(false)}
          onOk={handleStatusUpdate}
          style={{ top: 20 }}
          bodyStyle={{ overflow: "auto", maxHeight: "80vh" }}
        >
          <div>
            <TextArea
              rows={4}
              placeholder="Add a comment..."
              value={selectedGrievance?.comment}
              onChange={(e) =>
                setSelectedGrievance({
                  ...selectedGrievance,
                  comment: e.target.value,
                })
              }
              style={{ marginTop: "10px" }}
            />
          </div>
        </Modal>


        <Modal
        title="Share with User"
        visible={isModalOpen}
        onCancel={handleCancel}
        onOk={handleShare}
        okText="Share"
      >
        <p>Select a user to share with:</p>
        <Select
        mode="multiple"
          placeholder="Select user"
          style={{ width: '100%' }}
          onChange={(value) => setSelectedUsers(value)}
          value={selectedUsers}
          // showSearch
          // optionFilterProp="children"
          // filterOption={(input, option) =>
          //   option.children.toLowerCase().includes(input.toLowerCase())
          // }
        >
          {users.map((user) => (
            <Option key={user.id} value={user.name}>
              {user.name}
            </Option>
          ))}
        </Select>
      </Modal>

    </div>
  );
}

export default GreivanceTable;
